import { useEffect, useState } from 'react';
import type { ModuleItem } from '@kassa/shared';
import { api, ApiError } from '../../api';

// Paket (KT-99, Rüstəm 01.11 22:16): paketdə olmayan modul menyuda göstərilmir — burada görünür. Daxil olan modullar
// və «Əlavə modul istəyirəm» (sorğu platforma adminə gedir; açılmanı admin edir).

const FORM_LABEL: Record<string, string> = { simple: 'Sadə', standard: 'Standart', full: 'Tam', custom: 'Özün qur' };

export function PackagePanel() {
  const [modules, setModules] = useState<ModuleItem[] | null>(null);
  const [canRequest, setCanRequest] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState<string | null>(null);

  useEffect(() => {
    api
      .modules()
      .then((r) => {
        setModules(r.modules);
        setCanRequest(r.canRequest);
      })
      .catch((err: unknown) => setError(err instanceof ApiError ? err.message : 'Paket məlumatı yüklənmədi'));
  }, []);

  async function ask(m: ModuleItem) {
    setBusy(m.code);
    setError(null);
    try {
      await api.requestModule(m.code);
      setModules((cur) => cur?.map((x) => (x.code === m.code ? { ...x, request: 'new' } : x)) ?? cur);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Sorğu göndərilmədi. Yenidən cəhd edin.');
    } finally {
      setBusy(null);
    }
  }

  const open = modules?.filter((m) => m.open) ?? [];
  const closed = modules?.filter((m) => !m.open) ?? [];

  return (
    <section className="card card-wide" aria-label="Paket">
      <h2>Paket</h2>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      {!modules && !error && <p className="muted">Yüklənir…</p>}
      {modules && (
        <>
          <h3>Paketinizdə olan modullar</h3>
          <ul className="module-list">
            {open.map((m) => (
              <li key={m.code}>
                <span>{m.name}</span>
                <span className="badge badge-ok">Açıq</span>
              </li>
            ))}
          </ul>
          {closed.length > 0 && (
            <>
              <h3>Əlavə modullar</h3>
              <p className="muted small">Bu modullar paketinizdə yoxdur və menyuda göstərilmir.</p>
              <ul className="module-list">
                {closed.map((m) => (
                  <li key={m.code}>
                    <span>
                      {m.name}
                      {m.forms.length > 0 && <span className="muted small"> · {m.forms.map((f) => FORM_LABEL[f] ?? f).join(', ')} paketində</span>}
                    </span>
                    {m.request === 'new' ? (
                      <span className="ok small">Sorğu göndərilib</span>
                    ) : canRequest ? (
                      <button type="button" className="btn-small" onClick={() => void ask(m)} disabled={busy !== null}>
                        Əlavə modul istəyirəm
                      </button>
                    ) : (
                      <span className="muted small">Sahibdən istəyin</span>
                    )}
                  </li>
                ))}
              </ul>
            </>
          )}
        </>
      )}
    </section>
  );
}
